import { useI18n } from "@/i18n/I18nProvider";

export const LanguageSwitcher = ({ className = "", variant = "header" }) => {
  const { lang, setLang, langs } = useI18n();

  const base =
    variant === "mobile"
      ? "inline-flex items-center rounded-full border border-border/70 p-0.5 bg-background/60"
      : "inline-flex items-center rounded-full border border-foreground/15 p-0.5 bg-background/70 backdrop-blur";

  return (
    <div
      data-testid="language-switcher"
      className={`${base} ${className}`}
      role="group"
      aria-label="Language"
    >
      {langs.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => setLang(l.code)}
            data-testid={`lang-${l.code}`}
            aria-pressed={active}
            className={`px-3 py-1.5 text-xs font-semibold tracking-wide rounded-full transition-colors ${
              active
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
